import { TraceCategory, TraceDefinition } from '@sternum/web/features/monitoring/models';
import { OperatingSystemType } from '@sternum/web/features/product/models';
import { User } from '@sternum/web/features/user/models';

export type AlertId = string;
export type AlertRuleTraceId = string;
export type AlertDeviceId = string;

export enum AlertsTab {
  Alerts = 'alerts',
  AiAnomalies = 'ai-anomalies',
}

export interface AlertCategory {
  id: TraceCategory[number];
  displayName: string;
}

export interface AlertEventType {
  id: TraceDefinition['id'];
  displayName: TraceDefinition['name'];
}

export enum AlertSeverity {
  High = 'HIGH',
  Medium = 'MEDIUM',
  Regular = 'REGULAR',
  Low = 'LOW',
}

export enum AlertSource {
  BuiltIn = 'Built-in',
  User = 'User',
}

export interface AlertRuleTrace {
  id: AlertRuleTraceId;
  name: string;
  type: string;
  eventName: string;
  eventType: string;
  interest: AlertSeverity;
  traceCategory: TraceCategory;
}

export enum AlertResolveStatus {
  Resolved = 'RESOLVED',
  Dismissed = 'DISMISSED',
  Open = 'OPEN',
}

export enum IssueType {
  Alert = 'alert',
  Anomaly = 'anomaly',
  Attack = 'attack',
}

export interface AlertLocation {
  ip: string;
  country?: string;
  state?: string;
}

export interface AlertDevice {
  deviceId: AlertDeviceId;
  os: OperatingSystemType;
  createdAt: Date;
  lastSeenAt: Date;
  receivedDeviceId: string;
}

export type AlertReasonType = 'other' | string;

export interface AlertReason {
  type: AlertReasonType;
  text: string | 'other';
}

export interface AlertTableItem {
  id: string;
  severity?: AlertSeverity;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  eventType: string;
  issueType: IssueType;
  category: AlertCategory;
  receivedDeviceId: string;
  productId: string;
  productName: string;
  version: string;
  versionId: string;
  source?: AlertSource;
  reasons: AlertReason[];
  status: AlertResolveStatus;
  statusChangedBy?: Pick<User, 'id' | 'firstName' | 'secondName'> | null;
  isRemediated?: boolean;
}

export interface AlertsTableSort {
  field: AlertsTableSortField;
  direction: SortDirection;
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type AlertsTableSortField =
  | 'createdAt'
  | 'name'
  | 'eventType'
  | 'category'
  | 'productName'
  | 'productVersion'
  | 'receivedDeviceId'
  | 'source';

export enum AlertLogsWarningType {
  AttackAttempt = 'Attack Attempt',
}
